import React from 'react';
import {
  NodeHeading,
  NodeListItem,
  NodeList,
  NodeModal,
  NodeVideoPlayer,
  NodeContainer,
} from '../NodeComponents';
import { NodeModalProps } from './types';

const age = 4;
const nodeNumber = 0;

const ModalA4N1: React.FunctionComponent<NodeModalProps> = ({
  isOpen,
  onClose,
}) => (
  <NodeModal isOpen={isOpen} onClose={onClose}>
    <NodeVideoPlayer
      url="/assets/timelineModalMedia/WWD-Acct-KidTimeline-Age4-Knitcoin2-01:23-N1.mp4"
      ageId={age}
      nodeNumber={nodeNumber}
      index={0}
    />
    <NodeContainer>
      <NodeHeading>Knitcoin #2: Squirrel Invests!</NodeHeading>
      <NodeList isAcorn>
        <NodeListItem isAcorn>
          What is Squirrel doing with his money?
        </NodeListItem>
        <NodeListItem isAcorn>
          What happens when you do this in real life?
        </NodeListItem>
        <NodeListItem isAcorn>Does money grow?</NodeListItem>
      </NodeList>
    </NodeContainer>
  </NodeModal>
);

export default ModalA4N1;
